<template>
    <div class="chat-container">
        <aside class="sidebar" :class="{ 'expanded': isExpand }" @mouseenter="handleIsExpanded(true)"
            @mouseleave="handleIsExpanded(false)">
            <img class="message-icon" src="@/assets/img/chatbot/message.svg" alt="message icon" />
            <div @click="changeChatType(item.name)" v-for="item in menuItems" :key="item.name" class="sidebar-icon"
                :title="item.name" :class="{ 'active-icon': item.name === chatType }">
                <div class="icon-wrapper">
                    <img :src="item.icon" :alt="item.name" />
                    <span v-if="isExpand">{{ item.label }}</span>
                </div>
            </div>
        </aside>
        <div class="left-panel">

            <div class="search-box">
                <img src="@/assets/img/chatbot/chat/search.svg" alt="search icon" />
                <input type="text" placeholder="Search" class="search-input" />
            </div>

            <button class="new-chat-btn">
                <img src="@/assets/img/chatbot/chat/plus.svg" alt="plus" />
                Nuevo Chat
            </button>

            <div class="history-label">HOY</div>

            <div class="chat-history">
                <div class="history-item">
                    <div class="history-text">
                        <p>Conversación</p>
                        <span>Conversacion pasada</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="chat-placeholder">
            <div v-if="chatType === 'file'">
                <ChatFile :key="chatType" />
            </div>

            <div v-else-if="chatType === 'db'">
                <ChatDB :key="chatType" />
            </div>

            <div v-else-if="chatType === 'faq'">
                <ChatFaq :key="chatType" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ChatFile from '@/components/Chats/ChatFile.vue';
import ChatFaq from '@/components/Chats/ChatFaq.vue';
import ChatDB from '@/components/Chats/ChatDB.vue';

export default {
  name: 'Chat',
  components: { ChatFile, ChatFaq, ChatDB },
  data() {
    return {
      isExpand: false,
      menuItems: [
        { name: 'file', icon: require('@/assets/img/chatbot/chat/chat.svg'), label: 'Sube Documentos' },
        { name: 'db', icon: require('@/assets/img/chatbot/chat/db.svg'), label: 'Analiza tus Datos' },
        { name: 'faq', icon: require('@/assets/img/chatbot/chat/faq.svg'), label: 'Habla IA' }
      ]
    };
  },
  computed: {
    ...mapGetters(['chatType'])
  },
  methods: {
    ...mapActions(['changeChatType', 'resetChat']),
    handleIsExpanded(status) {
      this.isExpand = status;
    }
  }
};
</script>

<style>
.chat-container {
    background-color: #061821;
    display: flex;
    height: 100vh;
    font-family: Arial, sans-serif;
}

.active-icon {
    background-color: #136C94;
    border-radius: 5px;
    padding: 8rem 8rem;

}

.sidebar.expanded {
    width: 220px;
    align-items: start;
}

.sidebar {
    width: 70px;
    background-color: #17181B;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0;
    transition: width 0.7s ease;
    flex-shrink: 0;

}

.sidebar-icon {
    width: 100%;
    padding: 0.5rem 1rem;
    margin: 0.2rem auto;
    cursor: pointer;
    display: flex;
    justify-content: center;
}

.sidebar.expanded .sidebar-icon {
    justify-content: flex-start;
}

.icon-wrapper {
    display: flex;
    align-items: center;
    gap: 0.6rem;
}

.sidebar-icon img {
    width: 28px;
    height: 28px;
    filter: brightness(0) invert(1);
}

.message-icon {
    margin: 0.8rem 0;
    width: 30px;
    height: 30px;
}

.sidebar.expanded .message-icon {
    margin-left: 0.9rem
}



.left-panel {
    width: 220px;
    /* Si quieres que esta parte también sea flexible, quítale esta línea */
    background-color: #17181B;
    padding: 1rem;
    color: #fff;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    /* Opcional: evita que se encoja */
}

.search-box {
    display: flex;
    align-items: center;
    background-color: #2A2B2F;
    border-radius: 6px;
    padding: 0.4rem 0.6rem;
    margin-bottom: 1rem;
}

.search-box img {
    width: 16px;
    height: 16px;
    margin-right: 0.5rem;
    filter: brightness(0) invert(1);
}

.search-input {
    background: transparent;
    border: none;
    outline: none;
    color: #80868B;
    flex-grow: 1;
}


.new-chat-btn {
    background-color: #2c6b94;
    justify-content: center;
    border: none;
    color: white;
    padding: 0.5rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 12px;
    cursor: pointer;
    margin-bottom: 1.5rem;
}

.new-chat-btn img {
    width: 16px;
    height: 16px;
    filter: brightness(0) invert(1);
}

.history-label {
    font-size: 0.7rem;
    color: #80868B;
    margin-bottom: 0.5rem;
}

.chat-history {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.history-item {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.history-text p {
    margin: 0;
    font-size: 0.95rem;
}

.history-text span {
    font-size: 0.75rem;
    color: #80868B;
}

.chat-placeholder {
    flex: 1;
    background-color: #0a1a22;
    overflow: auto;
}

@media (max-width: 768px) {
    .sidebar {
        display: none;
    }

    .left-panel {
        display: none;
    }
}
</style>